import type { LucideIcon } from 'lucide-react'

import {
    AppWindow,
    ClipboardList,
    Command,
    Focus,
    GalleryVerticalEnd,
    Mic,
    NotebookPen,
    Pipette,
    Ruler,
    ScanEye,
    SquareTerminal,
    Trash2,
    WandSparkles
} from 'lucide-react'

export interface CustomKeycap {
    name: string
    icon: LucideIcon | 'hyper'
    href?: string
}

export const CUSTOM_KEYCAPS: CustomKeycap[] = [
    { name: 'Hyper Key', icon: 'hyper' },
    { name: 'Raycast Notes', icon: NotebookPen, href: 'https://manual.raycast.com/notes' },
    { name: 'Window Management', icon: AppWindow, href: 'https://www.raycast.com/core-features/window-management' },
    { name: 'Color Picker', icon: Pipette, href: 'https://www.raycast.com/thomas/color-picker' },
    { name: 'Move to Trash', icon: Trash2 },
    { name: 'Screenshot', icon: ScanEye },
    { name: 'Dictation', icon: Mic, href: 'https://manual.raycast.com/ai/dictation' },
    { name: 'Raycast Focus', icon: Focus, href: 'https://manual.raycast.com/focus' },
    { name: 'Ruler', icon: Ruler, href: 'https://www.raycast.com/anwarulislam/ruler' },
    { name: 'Command Shortcuts', icon: Command },
    { name: 'Quick AI', icon: WandSparkles, href: 'https://manual.raycast.com/ai/quick-ai' },
    { name: 'Clipboard History', icon: ClipboardList, href: 'https://manual.raycast.com/clipboard-history' },
    { name: 'Glaze', icon: GalleryVerticalEnd, href: 'https://www.glaze.app/' },
    { name: 'AI Chat', icon: SquareTerminal, href: 'https://manual.raycast.com/ai/ai-chat' }
]
